import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { MatchService } from '../match.service';

export const MATCH_FORM_QUERY_KEY = ['match', 'form'] as const;
export const MY_MATCH_QUERY_KEY = ['match', 'me'] as const;

/** Público — perguntas do /match. */
export const useGetMatchForm = (
	options?: Omit<UseQueryOptions<Match.Form, Error>, 'queryKey' | 'queryFn'>,
) => {
	return useQuery({
		queryKey: MATCH_FORM_QUERY_KEY,
		queryFn: () => MatchService.getForm(),
		refetchOnWindowFocus: false,
		staleTime: 5 * 60 * 1000,
		...options,
	});
};

/** Usuário logado — match já respondido nesta conta (se houver). */
export const useGetMyMatch = (
	options?: Omit<
		UseQueryOptions<Match.MyMatch, Error>,
		'queryKey' | 'queryFn'
	>,
) => {
	return useQuery({
		queryKey: MY_MATCH_QUERY_KEY,
		queryFn: () => MatchService.getMine(),
		refetchOnWindowFocus: false,
		...options,
	});
};
